import React, {useEffect, useState} from 'react';
import useDirection from "../../hooks/useDirection";

const Sort = ({data , sortKey ,onSort , parentKey , childKey}) => {
  const [sortType, setSortType] = useState(false);
  const directionClass = useDirection();

  useEffect(() => {
    if(data?.data) {
      if(parentKey) {
        data?.data?.sort((a,b) => (a[parentKey][sortKey] < b[parentKey][sortKey]) ? sortType ? 1 : -1 : ((b[parentKey][sortKey] < a[parentKey][sortKey]) ? sortType ? -1 :1 : 0))
      } else {
        if(childKey) {
          data?.data?.sort((a,b) => (a[childKey][childKey][sortKey] < b[childKey][childKey][sortKey]) ? sortType ? 1 : -1 : ((b[childKey][childKey][sortKey] < a[childKey][childKey][sortKey]) ? sortType ? -1 :1 : 0))
        } else {
          data?.data?.sort((a,b) => (a[sortKey] < b[sortKey]) ? sortType ? 1 : -1 : ((b[sortKey] < a[sortKey]) ? sortType ? -1 :1 : 0))

        }
      }
    } else {
      if(parentKey ) {
        data?.sort((a,b) => (a[parentKey][sortKey] < b[parentKey][sortKey]) ? sortType ? 1 : -1 : ((b[parentKey][sortKey] < a[parentKey][sortKey]) ? sortType ? -1 :1 : 0))
      } else {
        if(childKey) {
          data?.sort((a,b) => (a[childKey][childKey][sortKey] < b[childKey][childKey][sortKey]) ? sortType ? 1 : -1 : ((b[childKey][childKey][sortKey] < a[childKey][childKey][sortKey]) ? sortType ? -1 :1 : 0))
        } else {
          data?.sort((a,b) => (a[sortKey] < b[sortKey]) ? sortType ? 1 : -1 : ((b[sortKey] < a[sortKey]) ? sortType ? -1 :1 : 0))

        }
      }
    }
    onSort(data)

  } ,[sortType])

  return (
    <div onClick={() => setSortType(!sortType)} className={`flex flex-col ${directionClass ? "ml-2" : "mr-2"}  opacity-40 cursor-pointer`}>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path d="M6 0.295044L0 6.29504L1.41 7.70504L6 3.12504L10.59 7.70504L12 6.29504L6 0.295044Z" fill="black"/>
      </svg>
      </span>
     <span className={"mt-1"}>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path d="M6 7.70508L12 1.70508L10.59 0.295078L6 4.87508L1.41 0.295077L5.24537e-07 1.70508L6 7.70508Z" fill="black"/>
      </svg>
     </span>
    </div>
  );
};

export default Sort;
